import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzNotificationModule } from 'ng-zorro-antd/notification';

@NgModule({
    declarations: [],
    imports: [CommonModule, NzNotificationModule]
})
export class CoreModule {}
